class StateSelect {

    constructor() {
        this.state = '';
        this.address_id = '';

        this._debug = {
            set_all: true,
            get_all: true,
        }
    }
    
    _methods = { // ----------------------- Start Methods -----------------
        _setters: { // ----------------------- Start - Setters -------------------
            _properties: {
            },
            _ui: {
            }
        }, // ----------------------- End - Setters -------------------   
        _getters: { // ----------------------- Start - Getters -------------------
        }, // ----------------------- End - Getters -------------------
        _builders: { // ----------------------- Start - Builders -------------------
            build_state_select: (address_id) => {
                return am.$(this._methods._builders.build_state_select_html(address_id));
            },
            build_state_select_html: (address_id) => {
                return `
                    <div class="am-section-row address-state">
                        <label class="am-section-label" id="state-label" for="state-${address_id}">${get_language_translation('LANG_LABEL_STATE_PROVINCE')}</label> 
                        <div class="am-section-parent">

                            <select id="state-${address_id}" name="address[state][${address_id}]" class="am-select-dropdown js-required js-address-state places_state_${address_id}">
                                <option value="" selected >${get_language_translation('LANG_OPT_SELECT')}</option>
                            </select>
                        </div>
                    </div>
                `;
            }
        }, // ----------------------- End - Builders -------------------
        _helpers: { // ----------------------- Start - Helpers -------------------
            state_get_ajax: (element) => {
                const State = this;
                const $this = am.$(element);
                const $address_container = $this.parent().closest('.address-section');
                const $state = $address_container.find('.js-address-state');
                try{
                    State._methods._helpers.add_loading_state($state.attr('id'))
                    const $state_label = $state.parent().closest('.address-state').find('.am-section-label');

                    am.$.get('/ajax/states/get_states_by_country/?country='+$this.val(), function(data){
                        State._methods._helpers.remove_state_options($state);
                        State._methods._helpers.add_loading_state($state.attr('id'));
                        
                        if(data.states && data.states.length > 0){
                            if(($this.val() === 'United States') || ($this.val() === 'Canada')){
                                $state.addClass('js-required');
                                $state_label.text($state_label.data('state_province'));
                                show_required();
                            }else if($this.val() === 'Australia'){
                                $state.addClass('js-required');
                                $state_label.text( $state_label.data('state_territories'));
                                show_required();
                            }

                            let setState = $state.attr('data-state')
                            data.states.each((state, i) => {
                                const $opt = am.$(`<option value="${state.id}" ${state.id == setState ? 'selected' : '' } >${state.value}</option>`);
                                $state.append($opt);
                            })

                            $state_label.children('.req-astr').show();
                            if($state.prop('disabled'))
                               $state.prop('disabled', false);

                        }else{
                            if($state.length > 0){
                                $state.removeClass('js-required')
                                var id = $state.attr('id');
                                var scraped_id = id.replaceAll('[', '\\[');
                                    scraped_id = scraped_id.replaceAll(']', '\\]');
                                remove_error_classes($state_label, $state, scraped_id );
    
                                $state_label.children('.req-astr').hide();
                                $state.append(`<option>${get_language_translation('LANG_LABEL_NO_STATES_FOUND')}</option`);
                                $state.prop('disabled', true);
                            }
                        }
                    })
                    .done(function(e) {
                        State._methods._helpers.remove_state_loading($this.attr('id'))
                    })
                    .fail(function(e) {
                        console.log(e);
                    })
                }
                catch(e){
                    console.log(e);
                };
            },
            add_loading_state: (address_id) => {
                const $state = am.$(`#state-${address_id}`);
                this._methods._helpers.remove_state_options($state);
                $state.append(`<option id="loading-option[${address_id}]" value="" >"Loading..."</option>`);
            },
            remove_state_loading: (address_id) => {
                am.$(`#loading-option[${address_id}]`).remove();
            }, 
            remove_state_options: ($state) => {
                var opts = $state.children('option');
                opts.each((i, opt) => { am.$(opt).remove(); })
            }
        }, // ----------------------- End - Helpers -------------------
    } // ----------------------- End Std Methods -----------------
}
